import * as React from "react";
import type { SVGProps } from "react";
const SvgEvaluation = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 21 18"
    {...props}
  >
    <ellipse
      cx={13.578}
      cy={8.773}
      stroke="currentColor"
      strokeWidth={1.5}
      rx={5.304}
      ry={5.349}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
      d="m17.114 13.052 2.475 2.496m-4.988.67c-.947.946-2.47.946-5.519.946H7.466c-3.048 0-4.572 0-5.52-.947C1 15.272 1 13.748 1 10.7V7.466c0-3.048 0-4.572.947-5.52C2.894 1 4.417 1 7.466 1h1.616c3.048 0 4.572 0 5.52.947M4.233 9.082h2.425M4.233 5.85h3.233m-3.233 6.465h2.425"
    />
  </svg>
);
export default SvgEvaluation;
